// @flow
import * as React from 'react';
import algoliaSearch from 'utils/algoliaSearch';
import getSearchIndex from 'utils/search/getSearchIndex';
import TileCarousel from 'components/TileCarousel';
import type { CurrentUser } from 'api/currentUser';
import type { RouterHistory } from 'react-router';
import getSearchLocationOptions from 'utils/search/getSearchLocationOptions';
import getSearchConfig from 'utils/search/getSearchConfig';
import { listingSearchHomePath } from 'utils/searchHomePages';

const { useEffect, useState } = React;

const getRecommendedJobs = (currentUser: ?CurrentUser) => {
  const searchConfig = getSearchConfig();

  let locationOptions = {};
  if (
    currentUser &&
    currentUser.searchLocation &&
    currentUser.searchLocation.latitude &&
    currentUser.searchLocation.longitude
  ) {
    locationOptions = getSearchLocationOptions(
      'auto',
      currentUser.searchLocation
    ).locationOptions;
  }

  const queryOptions = {
    index: getSearchIndex(),
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url'
    ],
    facetFilters: [['type:JOB']],
    filters: '_tags:hasLogo',
    ...locationOptions
  };
  return algoliaSearch(searchConfig, '', queryOptions)
    .then(({ hits }) => hits)
    .catch();
};

const RecommendedJobs = ({
  headline,
  currentUser,
  history
}: {
  headline: string,
  currentUser: ?CurrentUser,
  history: RouterHistory
}) => {
  const [recommendedJobs, setRecommendedJobs] = useState([]);
  useEffect(
    () => {
      getRecommendedJobs(currentUser).then(jobs => {
        setRecommendedJobs(
          jobs.map(job => ({
            city: job.city,
            id: job.objectID,
            logo: job.logo,
            orgName: job.orgName,
            name: job.name,
            state: job.state,
            url: job.url
          }))
        );
      });
    },
    [currentUser]
  );

  return (
    <>
      {recommendedJobs && (
        <TileCarousel
          headline={headline}
          results={recommendedJobs}
          history={history}
          seeAllText={
            /* TRANSLATORS: Link to job search */ getText('See all jobs')
          }
          seeAllUrl={`${listingSearchHomePath('JOB')}?searchMode=true&q=`}
          listingType="JOB"
          carouselLocation="CMS Page"
        />
      )}
    </>
  );
};

export default RecommendedJobs;
